import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import AuthContext from '../context/auth-context';

import { GiHamburgerMenu } from 'react-icons/gi';
import { VscAdd } from "react-icons/vsc";

import profile from '../assets/logoufm1.png';
import classes from './Header.module.css';

function Header(props) {

    const authContext = useContext(AuthContext);
    const isLoggedIn = authContext.isLoggedIn;

    const onClickHandler = () => {
        props.onMenuToggle();
    };

    const logoutHandler = () => {
        authContext.logout();
    };

    let consStyle = {
        zIndex: '11',
        position: 'sticky',
        top: '0'
    }

    let toggleMenuIcon;
    let rotateMenuIcon;
    if(props.toggleMenu){
        rotateMenuIcon = classes.rotate45;
        toggleMenuIcon = <VscAdd/>;
    } else {
        rotateMenuIcon = "";
        toggleMenuIcon = <GiHamburgerMenu/>;
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light shadow bg-white d-flex justify-content-between" style={consStyle}>

            {/* TOGGLE MENU BUTTON */}
            <div 
                className={`${classes.hamburgerIcon} ${rotateMenuIcon}`}
                style={{marginLeft: '15px'}}
                onClick={onClickHandler}>
                {toggleMenuIcon}
            </div>

            {/* NAVBAR OPTIONS */}
            <div className="">
                <ul className="navbar-nav">
                    {
                        !isLoggedIn &&
                        <li className="nav-item">
                            <Link className="nav-link" to={"/login"}>Login</Link>
                        </li>
                    }
                    {
                        !isLoggedIn &&
                        <li className="nav-item">
                            <Link className="nav-link" to={"/registro"}>Registro</Link>
                        </li>
                    }
                    {
                        isLoggedIn &&
                        <li className="nav-item d-flex align-items-center px-1">
                            <Link className="btn btn-sm btn-outline-light text-black-50" to={"/"}>Inicio</Link>
                        </li>
                    }
                    {
                        isLoggedIn &&
                        <li className="nav-item d-flex align-items-center px-1">
                            <button className='btn btn-sm btn-outline-light text-black-50' onClick={logoutHandler}>Cerrar sesión</button>
                        </li>
                    }
                    {
                        isLoggedIn && 
                        <li className="nav-item">
                            <div className='px-3'>
                                <Link to={"/"}>
                                    <img src={profile} className="rounded-circle border border-success" style={{height: '40px', width: '40px'}} alt="Placeholder profile"></img>
                                </Link>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        </nav>
    )
}

export default Header;